module.exports = __webpack_public_path__ + "static/media/error401.750b1c5c.svg";